import * as React from 'react';
import { IYado, ICurrency } from '../types';
import YadoItemView from './views/YadoItemView';
import YadoItemPhoto from './YadoItemPhoto';
import YadoItemContent from './YadoItemContent';
import YadoItemAside from './YadoItemAside';

interface IProps {
  yado: IYado;
  uri: string;
  handleClick: null|((event: React.MouseEvent) => void);
  numberOfPeople: number,
  numberOfNights: number,
  currency: ICurrency,
}

const YadoItem: React.FC<IProps> = (props) => {
  const { yado, uri, handleClick, currency } = props;

  return (
    <YadoItemView href={uri} onClick={handleClick} target="_blank" rel="noopener noreferrer">
      <YadoItemPhoto yado={yado} />
      <YadoItemContent yado={yado} currency={currency} />
      <YadoItemAside {...props} />
    </YadoItemView>
  );
}

export default YadoItem;
